/* Justyol — phone + OTP order portal. */
(function () {
  'use strict';

  var root = document.querySelector('[data-jy-otpa]');
  if (!root) return;

  var base = String(window.JY_COD_ENDPOINT || '').replace(/\/+$/, '');
  var isAr = (document.documentElement.lang || '').indexOf('ar') === 0;
  var i18n = { statuses: {} };
  try {
    i18n = JSON.parse(root.querySelector('[data-jy-otpa-i18n]').textContent);
  } catch (e) {
    /* noop */
  }

  var phoneForm = root.querySelector('[data-jy-otpa-phone]');
  var codeForm = root.querySelector('[data-jy-otpa-code]');
  var ordersEl = root.querySelector('[data-jy-otpa-orders]');
  var listEl = root.querySelector('[data-jy-otpa-list]');
  var emptyEl = root.querySelector('[data-jy-otpa-empty]');
  var err1 = root.querySelector('[data-jy-otpa-err1]');
  var err2 = root.querySelector('[data-jy-otpa-err2]');
  var cdEl = root.querySelector('[data-jy-otpa-cd]');
  var resendBtn = root.querySelector('[data-jy-otpa-resend]');

  var TOKEN_KEY = 'jy_portal_token';
  var PHONE_KEY = 'jy_portal_phone';
  var currentPhone = '';
  var currentToken = '';

  function show(step) {
    phoneForm.hidden = step !== 'phone';
    codeForm.hidden = step !== 'code';
    ordersEl.hidden = step !== 'orders';
    /* advance the hero steps indicator */
    var idx = step === 'code' ? 1 : step === 'orders' ? 2 : 0;
    var chips = root.querySelectorAll('.jy-otpa__steps li');
    chips.forEach(function (li, i) {
      li.classList.toggle('on', i <= idx);
    });
  }
  function setErr(el, msg) {
    if (!el) return;
    el.hidden = !msg;
    if (msg) el.textContent = msg;
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    var s = btn.querySelector('.jy-codx__spin');
    var l = btn.querySelector('.jy-codx__submit-lbl');
    if (s) s.hidden = !on;
    if (l) l.style.opacity = on ? '0.5' : '1';
  }
  function post(path, body) {
    if (!base) return Promise.reject(new Error('no_endpoint'));
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r
        .json()
        .catch(function () {
          return {};
        })
        .then(function (j) {
          if (!r.ok || j.ok === false) throw new Error(j.error || 'error');
          return j;
        });
    });
  }
  function errMsg(code) {
    var m = {
      rate_limited: isAr ? 'محاولات كثيرة — جرّب بعد شوية.' : 'Trop de tentatives — réessayez plus tard.',
      invalid_phone: isAr ? 'رقم هاتف غير صحيح.' : 'Numéro invalide.',
      wrong_code: isAr ? 'الرمز غير صحيح.' : 'Code incorrect.',
      expired: isAr ? 'انتهت صلاحية الرمز — اطلب رمزًا جديدًا.' : 'Code expiré — demandez-en un nouveau.',
      too_many_tries: isAr ? 'محاولات كثيرة — اطلب رمزًا جديدًا.' : 'Trop d’essais — demandez un nouveau code.',
      otp_unavailable: isAr ? 'الخدمة غير مفعّلة بعد.' : 'Service pas encore activé.',
      send_failed: isAr ? 'تعذّر إرسال الرمز، حاول مجددًا.' : "Échec de l'envoi du code, réessayez.",
    };
    return m[code] || (isAr ? 'حدث خطأ، حاول مجددًا.' : 'Une erreur est survenue, réessayez.');
  }

  /* ---- countdown for resend ---- */
  var cdTimer = null;
  function startCountdown() {
    var n = 60;
    resendBtn.disabled = true;
    if (cdEl) cdEl.textContent = n;
    if (cdTimer) clearInterval(cdTimer);
    cdTimer = setInterval(function () {
      n -= 1;
      if (cdEl) cdEl.textContent = n;
      if (n <= 0) {
        clearInterval(cdTimer);
        resendBtn.disabled = false;
        if (cdEl) cdEl.textContent = '';
      }
    }, 1000);
  }

  function sendCode(phone, btn, errEl) {
    busy(btn, true);
    post('/otp/send', { phone: phone })
      .then(function (j) {
        currentPhone = phone;
        var sentTo = root.querySelector('[data-jy-otpa-sentto]');
        if (sentTo) sentTo.textContent = phone;
        show('code');
        startCountdown();
        setErr(err1, false);
        setErr(err2, false);
        /* dev mode: worker echoes the code until Zoko is wired */
        if (j.devCode) {
          var input = codeForm.querySelector('[name="code"]');
          if (input) input.placeholder = 'DEV: ' + j.devCode;
        }
        var ci = codeForm.querySelector('[name="code"]');
        if (ci) {
          ci.value = '';
          ci.focus();
        }
      })
      .catch(function (e) {
        setErr(errEl, errMsg(e.message));
      })
      .finally(function () {
        busy(btn, false);
      });
  }

  phoneForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(phoneForm);
    var cc = (fd.get('cc') || '212').replace(/[^\d]/g, '');
    /* national number: strip separators and any leading 0 (06.. -> 6..) */
    var nat = (fd.get('phone') || '').replace(/[^\d]/g, '').replace(/^0+/, '');
    if (nat.length < 6 || nat.length > 12) return setErr(err1, errMsg('invalid_phone'));
    sendCode('+' + cc + nat, root.querySelector('[data-jy-otpa-send]'), err1);
  });

  resendBtn.addEventListener('click', function () {
    if (currentPhone) sendCode(currentPhone, resendBtn, err2);
  });

  root.querySelector('[data-jy-otpa-back]').addEventListener('click', function () {
    show('phone');
  });

  /* hero steps are tappable: 1 → phone, 2 → code (if a code was sent),
     3 → orders (if a session exists) */
  root.querySelectorAll('.jy-otpa__steps li').forEach(function (li, i) {
    li.addEventListener('click', function () {
      if (i === 0) return show('phone');
      if (i === 1 && currentPhone) return show('code');
      if (i === 2) {
        try {
          var t = localStorage.getItem(TOKEN_KEY);
          if (t) loadOrders(t, localStorage.getItem(PHONE_KEY) || currentPhone || '');
        } catch (e) {
          /* noop */
        }
      }
    });
  });

  codeForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var code = (new FormData(codeForm).get('code') || '').trim();
    if (code.replace(/[^\d]/g, '').length !== 6) return setErr(err2, errMsg('wrong_code'));
    var btn = root.querySelector('[data-jy-otpa-verify]');
    busy(btn, true);
    post('/otp/verify', { phone: currentPhone, code: code })
      .then(function (j) {
        try {
          localStorage.setItem(TOKEN_KEY, j.token);
          localStorage.setItem(PHONE_KEY, currentPhone);
        } catch (err) {
          /* noop */
        }
        loadOrders(j.token, currentPhone);
      })
      .catch(function (e2) {
        setErr(err2, errMsg(e2.message));
      })
      .finally(function () {
        busy(btn, false);
      });
  });

  root.querySelector('[data-jy-otpa-logout]').addEventListener('click', function () {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(PHONE_KEY);
    } catch (e) {
      /* noop */
    }
    show('phone');
  });

  /* ---- delete account (App Store 5.1.1(v) / Play) ---- */
  var delBtn = root.querySelector('[data-jy-otpa-delete]');
  if (delBtn) {
    delBtn.addEventListener('click', function () {
      var msg = isAr
        ? 'هل أنت متأكد؟ سيتم حذف بياناتك نهائيًا ولا يمكن التراجع.'
        : 'Êtes-vous sûr ? Vos données seront supprimées définitivement, sans retour possible.';
      if (!window.confirm(msg)) return;
      var token = '';
      try {
        token = localStorage.getItem(TOKEN_KEY) || '';
      } catch (e) {}
      if (!token) {
        show('phone');
        return;
      }
      var delErr = root.querySelector('[data-jy-otpa-delerr]');
      if (delErr) delErr.hidden = true;
      busy(delBtn, true);
      post('/account/delete', { token: token })
        .then(function (j) {
          if (j && j.ok) {
            /* clear all local traces incl. the client-side wishlist */
            try {
              localStorage.removeItem(TOKEN_KEY);
              localStorage.removeItem(PHONE_KEY);
              localStorage.removeItem('justyol_wishlist');
            } catch (e) {}
            window.alert(isAr ? 'تم حذف حسابك.' : 'Votre compte a été supprimé.');
            show('phone');
          } else {
            if (delErr) {
              delErr.textContent = isAr ? 'تعذّر الحذف، حاول مرة أخرى.' : 'Échec de la suppression, réessayez.';
              delErr.hidden = false;
            }
          }
        })
        .catch(function () {
          if (delErr) {
            delErr.textContent = isAr ? 'تعذّر الحذف، حاول مرة أخرى.' : 'Échec de la suppression, réessayez.';
            delErr.hidden = false;
          }
        })
        .finally(function () {
          busy(delBtn, false);
        });
    });
  }

  /* ---- orders rendering ---- */
  function statusOf(o) {
    if (o.cancelled) return { label: i18n.statuses.cancelled, cls: 'is-cancel', stage: -1 };
    if (o.delivered) return { label: i18n.statuses.delivered || i18n.statuses.shipped, cls: 'is-done', stage: 3 };
    if (o.fulfillment === 'FULFILLED' || o.fulfillment === 'PARTIALLY_FULFILLED') {
      return { label: i18n.statuses.shipped, cls: 'is-shipped', stage: 2 };
    }
    return { label: i18n.statuses.preparing, cls: 'is-prep', stage: 1 };
  }
  /* mini progress timeline: Confirmée → Préparation → En route → Livrée */
  function timelineHtml(stage) {
    var steps = i18n.timeline || [];
    if (stage < 0 || !steps.length) return '';
    return (
      '<ol class="jy-otpa__tl" aria-hidden="true">' +
      steps
        .map(function (lbl, i) {
          var cls = i < stage ? 'is-done' : i === stage ? 'is-on' : '';
          return '<li class="' + cls + '"><i></i><span>' + esc(lbl) + '</span></li>';
        })
        .join('') +
      '</ol>'
    );
  }
  function fmtDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(isAr ? 'ar-MA' : 'fr-FR', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    } catch (e) {
      return '';
    }
  }
  function esc(s) {
    /* also escapes quotes — this output lands inside HTML attributes
       (a product title with a `"` would otherwise break out of value="") */
    return String(s || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  /* ---- loyalty: 1 point per 10 Dhs on non-cancelled orders.
     The worker computes earned/redeemed/available server-side; the local
     calculation stays as a fallback for older worker deploys. ---- */
  function renderLoyalty(orders, loyalty) {
    var card = root.querySelector('[data-jy-otpa-loyalty]');
    if (!card || !i18n.loyalty) return;
    var spent = orders.reduce(function (sum, o) {
      return o.cancelled ? sum : sum + parseFloat(o.total || 0);
    }, 0);
    var earned = loyalty ? loyalty.earned : Math.floor(spent / 10);
    var pts = loyalty ? loyalty.available : earned;
    var tiers = i18n.loyalty.tiers || [];
    /* tier rank follows lifetime points (earned); the displayed balance is
       what's still redeemable (available) */
    var tier = tiers[0];
    var next = null;
    tiers.forEach(function (t) {
      if (earned >= t.at) tier = t;
      else if (!next) next = t;
    });
    var ptsEl = root.querySelector('[data-jy-otpa-pts]');
    var tierEl = root.querySelector('[data-jy-otpa-tier]');
    var bar = root.querySelector('[data-jy-otpa-loybar]');
    var nextEl = root.querySelector('[data-jy-otpa-loynext]');
    if (ptsEl) ptsEl.textContent = pts;
    if (tierEl) tierEl.textContent = tier.icon + ' ' + tier.name;
    if (bar) {
      var pct = next ? Math.min(100, Math.round(((earned - tier.at) / (next.at - tier.at)) * 100)) : 100;
      bar.style.width = Math.max(4, pct) + '%';
    }
    if (nextEl) {
      nextEl.textContent = next
        ? (next.at - earned) + ' ' + i18n.loyalty.next + ' ' + next.icon + ' ' + next.name
        : i18n.loyalty.max;
    }
    renderRedeem(loyalty || { available: pts, tiers: null });
    /* always visible post-login — the program has to be seen to work */
    card.hidden = false;
  }

  /* ---- points → coupon redemption ---- */
  function renderRedeem(loyalty) {
    var wrap = root.querySelector('[data-jy-otpa-redeem]');
    var btns = root.querySelector('[data-jy-otpa-redeembtns]');
    if (!wrap || !btns) return;
    var tx = i18n.walletTx || {};
    if (!loyalty) {
      wrap.hidden = true;
      return;
    }
    /* older worker deploys don't send tiers — render the standard ladder so
       the program is always visible (buttons stay disabled until affordable) */
    var tiers =
      loyalty.tiers && loyalty.tiers.length
        ? loyalty.tiers
        : [
            { pts: 300, mad: 15 },
            { pts: 600, mad: 35 },
            { pts: 1000, mad: 65 },
          ];
    wrap.hidden = false;
    btns.innerHTML = tiers
      .map(function (t) {
        var can = loyalty.available >= t.pts;
        return (
          '<button type="button" class="jy-otpa__redeem-btn' + (can ? '' : ' is-off') + '"' +
          (can ? '' : ' disabled') + ' data-jy-otpa-doredeem="' + t.pts + '">' +
          '<b>' + t.mad + ' Dhs</b><span>' + t.pts + ' ' + esc(tx.pts || 'pts') + '</span>' +
          (can ? '' : '<small>' + esc((tx.missing || '{N}').replace('{N}', t.pts - loyalty.available)) + '</small>') +
          '</button>'
        );
      })
      .join('');
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jy-otpa-doredeem]');
    if (!btn || btn.disabled) return;
    var tx = i18n.walletTx || {};
    var errEl = root.querySelector('[data-jy-otpa-rederr]');
    var old = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<b>' + esc(tx.redeeming || '…') + '</b>';
    setErr(errEl, false);
    post('/loyalty/redeem', { token: currentToken, pts: parseInt(btn.getAttribute('data-jy-otpa-doredeem'), 10) })
      .then(function (j) {
        /* keep lastPayload in sync — later re-renders (return/review/cancel)
           rebuild from it and would otherwise revert to stale data */
        if (j.loyalty) lastPayload.loyalty = j.loyalty;
        if (j.coupons) lastPayload.coupons = j.coupons;
        renderRedeem(j.loyalty);
        var ptsEl = root.querySelector('[data-jy-otpa-pts]');
        if (ptsEl && j.loyalty) ptsEl.textContent = j.loyalty.available;
        renderCoupons(j.coupons || [], true);
        setErr(errEl, tx.redeemed || 'OK');
        if (errEl) errEl.classList.add('is-ok');
      })
      .catch(function (e2) {
        btn.disabled = false;
        btn.innerHTML = old;
        var code = String(e2.message);
        if (errEl) errEl.classList.remove('is-ok');
        setErr(
          errEl,
          code === 'scope_missing'
            ? tx.scopeMissing
            : code === 'not_enough_points'
              ? tx.notEnough
              : errMsg(code)
        );
      });
  });

  /* ---- coupons wallet ---- */
  function renderCoupons(coupons, scrollTo) {
    var sec = root.querySelector('[data-jy-otpa-coupons]');
    var list = root.querySelector('[data-jy-otpa-couponlist]');
    if (!sec || !list) return;
    var tx = i18n.walletTx || {};
    sec.hidden = false;
    if (!coupons || !coupons.length) {
      list.innerHTML = '<p class="jy-otpa__coupon-empty">' + esc(tx.none || '') + '</p>';
      return;
    }
    list.innerHTML = coupons
      .map(function (c) {
        var exp = c.exp ? fmtDate(c.exp) : '';
        return (
          '<div class="jy-otpa__coupon' + (c.used ? ' is-used' : '') + '">' +
          '<span class="jy-otpa__coupon-amt"><b>' + Number(c.mad) + '</b> ' + esc(tx.offAmount || 'Dhs') + '</span>' +
          '<span class="jy-otpa__coupon-mid">' +
          '<code class="jy-ltr">' + esc(c.code) + '</code>' +
          (exp && !c.used ? '<small>' + esc(tx.expires || '') + ' ' + exp + '</small>' : '') +
          (c.used ? '<small>' + esc(tx.used || '') + '</small>' : '') +
          '</span>' +
          (c.used
            ? ''
            : '<span class="jy-otpa__coupon-btns">' +
              '<button type="button" class="jy-otpa__obtn" data-jy-otpa-ccopy="' + esc(c.code) + '">' + esc(tx.copy || 'Copier') + '</button>' +
              '<button type="button" class="jy-otpa__obtn jy-otpa__obtn--re" data-jy-otpa-cuse="' + esc(c.code) + '">' + esc(tx.use || 'Utiliser') + '</button>' +
              '</span>') +
          '</div>'
        );
      })
      .join('');
    if (scrollTo) sec.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  root.addEventListener('click', function (e) {
    var copyBtn = e.target.closest('[data-jy-otpa-ccopy]');
    if (copyBtn) {
      var tx = i18n.walletTx || {};
      var codeToCopy = copyBtn.getAttribute('data-jy-otpa-ccopy');
      try {
        localStorage.setItem('jy_coupon', codeToCopy); /* checkout auto-applies it */
      } catch (err) {
        /* noop */
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(codeToCopy).then(function () {
          var old = copyBtn.textContent;
          copyBtn.textContent = tx.copied || '✓';
          setTimeout(function () {
            copyBtn.textContent = old;
          }, 1600);
        });
      }
      return;
    }
    var useBtn = e.target.closest('[data-jy-otpa-cuse]');
    if (useBtn) {
      try {
        localStorage.setItem('jy_coupon', useBtn.getAttribute('data-jy-otpa-cuse'));
      } catch (err) {
        /* noop */
      }
      window.location.href = (i18n.cartUrl || '/cart') + '?view=checkout';
    }
  });

  /* ---- store credit card ---- */
  function renderCredit(credit) {
    var card = root.querySelector('[data-jy-otpa-credit]');
    var bal = root.querySelector('[data-jy-otpa-creditbal]');
    var tx = root.querySelector('[data-jy-otpa-credittx]');
    if (!card || !bal) return;
    /* the wallet card is always visible (Figma My Account style) — a 0 Dhs
       balance still teaches customers that refunds become instant credit */
    var cents = credit && credit.balance ? credit.balance : 0;
    card.hidden = false;
    bal.textContent = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
    if (tx) {
      tx.innerHTML = (credit.tx || [])
        .slice(0, 3)
        .map(function (t) {
          var neg = t.amt < 0;
          return (
            '<div class="jy-otpa__credit-line' + (neg ? ' is-neg' : '') + '">' +
            '<span>' + esc((neg ? i18n.creditTxOrder : i18n.creditTxAdd) + ' · ' + (t.reason || '')) + '</span>' +
            '<b>' + (neg ? '−' : '+') + Math.abs(t.amt / 100) + ' Dhs</b>' +
            '</div>'
          );
        })
        .join('');
    }
  }

  /* ---- referral / parrainage ---- */
  function renderReferral(refCode, refMad) {
    var card = root.querySelector('[data-jy-otpa-ref]');
    if (!card) return;
    if (!refCode) {
      card.hidden = true;
      return;
    }
    card.hidden = false;
    var codeEl = root.querySelector('[data-jy-otpa-refcode]');
    var descEl = root.querySelector('[data-jy-otpa-refdesc]');
    var waEl = root.querySelector('[data-jy-otpa-refwa]');
    var rf = i18n.referral || {};
    if (codeEl) codeEl.textContent = refCode;
    if (descEl) descEl.textContent = (rf.desc || '').split('{N}').join(refMad || 20);
    if (waEl) {
      var msg = (rf.waMsg || '').split('{CODE}').join(refCode).split('{N}').join(refMad || 20);
      waEl.href = 'https://wa.me/?text=' + encodeURIComponent(msg);
    }
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jy-otpa-refcopy]');
    if (!btn) return;
    var codeEl = root.querySelector('[data-jy-otpa-refcode]');
    if (!codeEl || !navigator.clipboard) return;
    navigator.clipboard.writeText(codeEl.textContent.trim()).then(function () {
      var tx = i18n.walletTx || {};
      var old = btn.textContent;
      btn.textContent = tx.copied || '✓';
      setTimeout(function () {
        btn.textContent = old;
      }, 1600);
    });
  });

  /* ---- saved address: display + edit + cross-device checkout prefill ---- */
  var currentAddr = null;
  function renderAddress(addr) {
    var sec = root.querySelector('[data-jy-otpa-addr]');
    var txt = root.querySelector('[data-jy-otpa-addrtxt]');
    if (!sec || !txt) return;
    if (!addr || !addr.address) {
      sec.hidden = true;
      return;
    }
    currentAddr = addr;
    sec.hidden = false;
    txt.textContent = [addr.name, addr.address, addr.city].filter(Boolean).join(' · ');
    try {
      if (!localStorage.getItem('jy_cod_customer')) {
        localStorage.setItem('jy_cod_customer', JSON.stringify(addr));
      }
    } catch (e) {
      /* noop */
    }
  }

  var addrForm = root.querySelector('[data-jy-otpa-addrform]');
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-jy-otpa-addredit]')) {
      if (!addrForm) return;
      var citySel = addrForm.querySelector('[data-jy-otpa-addrcity]');
      if (citySel && window.JY_CITIES && citySel.options.length <= 1) {
        var frag = document.createDocumentFragment();
        window.JY_CITIES.forEach(function (c) {
          var op = document.createElement('option');
          op.value = c;
          op.textContent = c;
          frag.appendChild(op);
        });
        citySel.appendChild(frag);
      }
      if (currentAddr) {
        addrForm.querySelector('[name="name"]').value = currentAddr.name || '';
        addrForm.querySelector('[name="address"]').value = currentAddr.address || '';
        if (citySel) citySel.value = currentAddr.city || '';
      }
      addrForm.hidden = !addrForm.hidden;
      return;
    }
    if (e.target.closest('[data-jy-otpa-addrcancel]')) {
      if (addrForm) addrForm.hidden = true;
    }
  });
  if (addrForm) {
    addrForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var atx = i18n.addr || {};
      var errEl = addrForm.querySelector('[data-jy-otpa-addrerr]');
      var name = addrForm.querySelector('[name="name"]').value.trim();
      var city = addrForm.querySelector('[name="city"]').value.trim();
      var address = addrForm.querySelector('[name="address"]').value.trim();
      if (name.length < 3 || !city || address.length < 5) return setErr(errEl, atx.invalid || '!');
      var btn = addrForm.querySelector('[data-jy-otpa-addrsave]');
      var origLbl = btn.textContent;
      btn.disabled = true;
      btn.textContent = atx.saving || '…';
      post('/address/save', { token: currentToken, name: name, city: city, address: address })
        .then(function (j) {
          lastPayload.address = j.address;
          renderAddress(j.address);
          try {
            localStorage.setItem('jy_cod_customer', JSON.stringify(j.address)); /* edited → overwrite */
          } catch (err) {
            /* noop */
          }
          addrForm.hidden = true;
          btn.disabled = false;
          btn.textContent = origLbl;
        })
        .catch(function (e2) {
          btn.disabled = false;
          btn.textContent = origLbl;
          setErr(errEl, errMsg(e2.message));
        });
    });
  }

  var lastOrders = [];
  var lastPayload = {};
  var lastPhone = '';

  function renderOrders(orders, phone, payload) {
    lastOrders = orders;
    lastPayload = payload = payload || lastPayload || {};
    lastPhone = phone;
    var who = root.querySelector('[data-jy-otpa-who]');
    if (who) who.textContent = phone;
    /* hub stats: total + in-progress (not cancelled, not fulfilled) */
    var stats = root.querySelector('[data-jy-otpa-stats]');
    if (stats) {
      var active = orders.filter(function (o) {
        return !o.cancelled && !o.delivered && o.fulfillment !== 'FULFILLED';
      }).length;
      var c = root.querySelector('[data-jy-otpa-count]');
      var a = root.querySelector('[data-jy-otpa-active]');
      if (c) c.textContent = orders.length;
      if (a) a.textContent = active;
      stats.hidden = orders.length === 0;
    }
    renderLoyalty(orders, payload.loyalty || null);
    renderCoupons(payload.coupons || []);
    renderAddress(payload.address || null);
    renderCredit(payload.credit || null);
    renderReferral(payload.refCode || null, payload.refMad || 20);
    var returnsByOrder = {};
    (payload.returns || []).forEach(function (r) {
      if (!returnsByOrder[r.order]) returnsByOrder[r.order] = r; /* newest first */
    });
    var reviewedSet = {};
    (payload.reviewed || []).forEach(function (n) {
      reviewedSet[n] = true;
    });
    var wa = (i18n.wa || '').replace(/[^\d]/g, '');
    if (!orders.length) {
      listEl.innerHTML = '';
      emptyEl.hidden = false;
    } else {
      emptyEl.hidden = true;
      listEl.innerHTML = orders
        .map(function (o, idx) {
          var st = statusOf(o);
          var thumbs = o.items
            .slice(0, 4)
            .map(function (it) {
              return it.image
                ? '<img src="' + esc(it.image) + '" alt="" width="40" height="40" loading="lazy">'
                : '';
            })
            .join('');
          var items = o.items
            .map(function (it) {
              return esc(it.title) + ' × ' + it.qty;
            })
            .join(' · ');
          var canReorder = o.items.some(function (it) {
            return it.variantId;
          });
          var ret = returnsByOrder[o.name];
          var rtx = i18n.returns || {};
          var btns = '';
          if (canReorder) {
            btns +=
              '<button type="button" class="jy-otpa__obtn jy-otpa__obtn--re" data-jy-otpa-reorder="' + idx + '">' +
              esc(i18n.actions.reorder) + '</button>';
          }
          /* self-service return flow (was a bare WhatsApp link) */
          if (!o.cancelled && !ret && (o.fulfillment === 'FULFILLED' || o.delivered)) {
            btns +=
              '<button type="button" class="jy-otpa__obtn jy-otpa__obtn--ret" data-jy-otpa-retopen="' + idx + '">' +
              esc(rtx.open || i18n.actions.returnx) + '</button>';
          }
          if (wa) {
            btns +=
              '<a class="jy-otpa__obtn" target="_blank" rel="noopener" href="https://wa.me/' + wa +
              '?text=' + encodeURIComponent(i18n.actions.waProblem + o.name) + '">' +
              esc(i18n.actions.problem) + '</a>';
          }
          /* self-cancel while still unshipped — the cheapest COD save there is */
          if (st.stage === 1 && i18n.actions.cancelOrder) {
            btns +=
              '<button type="button" class="jy-otpa__obtn jy-otpa__obtn--cxl" data-jy-otpa-cancel="' + idx + '">' +
              esc(i18n.actions.cancelOrder) + '</button>';
          }
          /* live return status */
          var retChip = '';
          if (ret && rtx.status && rtx.status[ret.status]) {
            retChip =
              '<div class="jy-otpa__retst is-' + esc(ret.status) + '">' + esc(rtx.status[ret.status]) + '</div>';
          }
          /* post-delivery review CTA (+points) */
          var revBlock = '';
          var rvx = i18n.review || {};
          if (o.delivered && !o.cancelled) {
            revBlock = reviewedSet[o.name]
              ? '<div class="jy-otpa__revdone">' + esc(rvx.already || '') + '</div>'
              : '<button type="button" class="jy-otpa__rev-cta" data-jy-otpa-revopen="' + idx + '">⭐ ' +
                esc((rvx.cta || '').replace('{N}', '20')) + '</button>';
          }
          /* tap the card header → expanded receipt (line prices + totals) */
          var dtx = i18n.detail || {};
          var detail = '';
          if (o.subtotal != null) {
            detail =
              '<div class="jy-otpa__odetail" data-jy-otpa-odetail hidden>' +
              o.items
                .map(function (it) {
                  return (
                    '<div class="jy-otpa__odetail-row"><span>' + esc(it.title) + ' × ' + it.qty + '</span><b>' +
                    (it.lineTotal != null ? Math.round(parseFloat(it.lineTotal)) + ' Dhs' : '—') + '</b></div>'
                  );
                })
                .join('') +
              '<div class="jy-otpa__odetail-row jy-otpa__odetail-row--sub"><span>' + esc(dtx.subtotal || '') + '</span><b>' +
              Math.round(parseFloat(o.subtotal)) + ' Dhs</b></div>' +
              (parseFloat(o.discount || 0) > 0
                ? '<div class="jy-otpa__odetail-row jy-otpa__odetail-row--disc"><span>' + esc(dtx.discount || '') +
                  '</span><b>−' + Math.round(parseFloat(o.discount)) + ' Dhs</b></div>'
                : '') +
              '<div class="jy-otpa__odetail-row"><span>' + esc(dtx.shipping || '') + '</span><b>' +
              (parseFloat(o.shipping || 0) > 0 ? Math.round(parseFloat(o.shipping)) + ' Dhs' : esc(dtx.free || '0')) + '</b></div>' +
              '<div class="jy-otpa__odetail-row jy-otpa__odetail-row--total"><span>' + esc(dtx.total || '') + '</span><b>' +
              Math.round(parseFloat(o.total || 0)) + ' Dhs</b></div>' +
              '</div>';
          }
          return (
            '<div class="jy-otpa__order">' +
            '<div class="jy-otpa__order-top' + (detail ? ' jy-otpa__order-top--tap" data-jy-otpa-otoggle="' + idx : '') + '">' +
            '<b>' + esc(o.name) + '</b>' +
            '<span class="jy-otpa__order-top-right">' +
            '<span class="jy-otpa__st ' + st.cls + '">' + esc(st.label) + '</span>' +
            (detail ? '<svg class="jy-otpa__ochev" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' : '') +
            '</span>' +
            '</div>' +
            timelineHtml(st.stage) +
            (thumbs ? '<div class="jy-otpa__thumbs">' + thumbs + '</div>' : '') +
            '<div class="jy-otpa__order-items">' + items + '</div>' +
            detail +
            '<div class="jy-otpa__order-foot">' +
            '<span>' + fmtDate(o.createdAt) + '</span>' +
            '<b>' + Math.round(parseFloat(o.total || 0)) + ' ' + (isAr ? 'درهم' : 'Dhs') + '</b>' +
            '</div>' +
            (o.tracking && (o.tracking.url || o.tracking.number)
              ? '<a class="jy-otpa__track" target="_blank" rel="noopener" href="' +
                esc(o.tracking.url || '#') + '">' + esc(i18n.statuses.track) +
                (o.tracking.number ? ' · ' + esc(o.tracking.number) : '') + '</a>'
              : '') +
            retChip +
            revBlock +
            (btns ? '<div class="jy-otpa__obtns">' + btns + '</div>' : '') +
            '<div class="jy-otpa__obox" data-jy-otpa-obox="' + idx + '"></div>' +
            '</div>'
          );
        })
        .join('');
    }
    show('orders');
  }

  /* ---- inline return / exchange flow ---- */
  function openReturnForm(idx) {
    var o = lastOrders[idx];
    var box = root.querySelector('[data-jy-otpa-obox="' + idx + '"]');
    if (!o || !box) return;
    var rtx = i18n.returns || {};
    var reasons = rtx.reasons || {};
    box.innerHTML =
      '<div class="jy-otpa__retform">' +
      '<b>' + esc(rtx.title || '') + '</b>' +
      '<p class="jy-otpa__retform-lbl">' + esc(rtx.pick || '') + '</p>' +
      o.items
        .map(function (it, i) {
          var label = it.title + ' × ' + it.qty;
          return (
            '<label class="jy-otpa__retitem"><input type="checkbox" value="' + esc(label) + '"' +
            (o.items.length === 1 ? ' checked' : '') + '><span>' + esc(label) + '</span></label>'
          );
        })
        .join('') +
      '<p class="jy-otpa__retform-lbl">' + esc(rtx.reason || '') + '</p>' +
      '<select class="jy-otpa__retsel" data-jy-otpa-retreason>' +
      Object.keys(reasons)
        .map(function (k) {
          return '<option value="' + k + '">' + esc(reasons[k]) + '</option>';
        })
        .join('') +
      '</select>' +
      '<div class="jy-otpa__retkinds">' +
      '<label class="jy-otpa__retkind"><input type="radio" name="jyretkind' + idx + '" value="refund" checked><span>' +
      esc(rtx.kindRefund || '') + '</span></label>' +
      '<label class="jy-otpa__retkind"><input type="radio" name="jyretkind' + idx + '" value="exchange"><span>' +
      esc(rtx.kindExchange || '') + '</span></label>' +
      '</div>' +
      '<textarea class="jy-otpa__retnote" data-jy-otpa-retnote rows="2" placeholder="' + esc(rtx.note || '') + '"></textarea>' +
      '<p class="jy-codx__err" data-jy-otpa-reterr hidden></p>' +
      '<div class="jy-otpa__obtns">' +
      '<button type="button" class="jy-otpa__obtn jy-otpa__obtn--re" data-jy-otpa-retsend="' + idx + '">' +
      esc(rtx.send || '') + '</button>' +
      '<button type="button" class="jy-otpa__obtn" data-jy-otpa-retcancel="' + idx + '">' + esc(rtx.cancel || '') + '</button>' +
      '</div>' +
      '</div>';
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function sendReturn(idx, btn) {
    var o = lastOrders[idx];
    var box = root.querySelector('[data-jy-otpa-obox="' + idx + '"]');
    if (!o || !box) return;
    var rtx = i18n.returns || {};
    var errEl = box.querySelector('[data-jy-otpa-reterr]');
    var itemsSel = [].slice.call(box.querySelectorAll('.jy-otpa__retitem input:checked')).map(function (c) {
      return c.value;
    });
    if (!itemsSel.length) return setErr(errEl, rtx.needItems || '!');
    var reasonSel = box.querySelector('[data-jy-otpa-retreason]');
    var kindSel = box.querySelector('input[name="jyretkind' + idx + '"]:checked');
    var noteEl = box.querySelector('[data-jy-otpa-retnote]');
    btn.disabled = true;
    btn.textContent = rtx.sending || '…';
    post('/returns/create', {
      token: currentToken,
      order: o.name,
      items: itemsSel,
      reason: reasonSel ? reasonSel.value : 'other',
      kind: kindSel ? kindSel.value : 'refund',
      note: noteEl ? noteEl.value.trim() : '',
    })
      .then(function (j) {
        lastPayload.returns = j.returns || [];
        renderOrders(lastOrders, lastPhone, lastPayload);
      })
      .catch(function (e2) {
        btn.disabled = false;
        btn.textContent = rtx.send || 'OK';
        setErr(errEl, String(e2.message) === 'return_exists' ? rtx.exists : errMsg(e2.message));
      });
  }

  /* ---- inline review (stars + comment → +points) ---- */
  function openReviewForm(idx) {
    var o = lastOrders[idx];
    var box = root.querySelector('[data-jy-otpa-obox="' + idx + '"]');
    if (!o || !box) return;
    var rvx = i18n.review || {};
    box.innerHTML =
      '<div class="jy-otpa__revform" data-jy-otpa-revform data-rating="0">' +
      '<div class="jy-otpa__stars">' +
      [1, 2, 3, 4, 5]
        .map(function (n) {
          return '<button type="button" class="jy-otpa__star" data-jy-otpa-star="' + n + '" aria-label="' + n + '/5">★</button>';
        })
        .join('') +
      '</div>' +
      '<textarea class="jy-otpa__retnote" data-jy-otpa-revnote rows="2" placeholder="' + esc(rvx.placeholder || '') + '"></textarea>' +
      '<p class="jy-codx__err" data-jy-otpa-reverr hidden></p>' +
      '<div class="jy-otpa__obtns">' +
      '<button type="button" class="jy-otpa__obtn jy-otpa__obtn--re" data-jy-otpa-revsend="' + idx + '">' +
      esc(rvx.send || 'OK') + '</button>' +
      '</div>' +
      '</div>';
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function sendReview(idx, btn) {
    var o = lastOrders[idx];
    var box = root.querySelector('[data-jy-otpa-obox="' + idx + '"]');
    if (!o || !box) return;
    var rvx = i18n.review || {};
    var errEl = box.querySelector('[data-jy-otpa-reverr]');
    var formEl = box.querySelector('[data-jy-otpa-revform]');
    var rating = formEl ? parseInt(formEl.getAttribute('data-rating'), 10) || 0 : 0;
    if (!rating) return setErr(errEl, rvx.needStars || '!');
    var noteEl = box.querySelector('[data-jy-otpa-revnote]');
    btn.disabled = true;
    post('/reviews/create', {
      token: currentToken,
      order: o.name,
      rating: rating,
      comment: noteEl ? noteEl.value.trim() : '',
    })
      .then(function (j) {
        lastPayload.reviewed = (lastPayload.reviewed || []).concat([o.name]);
        if (lastPayload.loyalty && j.bonus) {
          lastPayload.loyalty.earned += j.bonus;
          lastPayload.loyalty.available += j.bonus;
        }
        renderOrders(lastOrders, lastPhone, lastPayload);
      })
      .catch(function (e2) {
        btn.disabled = false;
        setErr(errEl, String(e2.message) === 'already_reviewed' ? rvx.already : errMsg(e2.message));
      });
  }

  /* ---- self-cancel: reason sheet (Figma 112) → confirm ---- */
  function openCancelForm(idx) {
    var o = lastOrders[idx];
    var box = root.querySelector('[data-jy-otpa-obox="' + idx + '"]');
    if (!o || !box) return;
    var cx = i18n.cancelx || {};
    var reasons = cx.reasons || {};
    box.innerHTML =
      '<div class="jy-otpa__retform">' +
      '<b>' + esc(cx.title || '') + '</b>' +
      Object.keys(reasons)
        .map(function (k, i) {
          return (
            '<label class="jy-otpa__retkind"><input type="radio" name="jycxl' + idx + '" value="' + k + '"' +
            (i === 0 ? ' checked' : '') + '><span>' + esc(reasons[k]) + '</span></label>'
          );
        })
        .join('') +
      '<p class="jy-codx__err" data-jy-otpa-cxlerr hidden></p>' +
      '<div class="jy-otpa__obtns">' +
      '<button type="button" class="jy-otpa__obtn jy-otpa__obtn--cxl" data-jy-otpa-cxlgo="' + idx + '">' +
      esc(cx.confirm || '') + '</button>' +
      '<button type="button" class="jy-otpa__obtn" data-jy-otpa-retcancel="' + idx + '">' + esc(cx.keep || '') + '</button>' +
      '</div>' +
      '</div>';
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function cancelOrder(idx, btn) {
    var o = lastOrders[idx];
    var box = root.querySelector('[data-jy-otpa-obox="' + idx + '"]');
    if (!o || !box) return;
    var a = i18n.actions;
    var errEl = box.querySelector('[data-jy-otpa-cxlerr]');
    var sel = box.querySelector('input[name="jycxl' + idx + '"]:checked');
    btn.disabled = true;
    btn.textContent = a.cancelling || '…';
    post('/orders/cancel', { token: currentToken, order: o.name, reason: sel ? sel.value : 'other' })
      .then(function () {
        o.cancelled = true;
        renderOrders(lastOrders, lastPhone, lastPayload);
      })
      .catch(function (e2) {
        btn.disabled = false;
        btn.textContent = (i18n.cancelx || {}).confirm || 'OK';
        setErr(errEl, String(e2.message) === 'too_late' ? a.cancelTooLate : errMsg(e2.message));
      });
  }

  /* ---- quick nav chips → smooth-scroll to sections ---- */
  var NAV_TARGETS = {
    orders: '.jy-otpa__list-title:not([data-x])',
    loyalty: '[data-jy-otpa-loyalty]',
    coupons: '[data-jy-otpa-coupons]',
    addr: '[data-jy-otpa-addr]',
    faq: '.jy-otpa__faq',
  };
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-jy-otpa-nav]');
    if (!chip) return;
    var key = chip.getAttribute('data-jy-otpa-nav');
    var el =
      key === 'orders'
        ? root.querySelector('[data-jy-otpa-list]')
        : root.querySelector(NAV_TARGETS[key] || '');
    if (el && !el.hidden) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-jy-otpa-otoggle]'))) {
      var card = t.closest('.jy-otpa__order');
      var det = card && card.querySelector('[data-jy-otpa-odetail]');
      if (det) {
        det.hidden = !det.hidden;
        t.classList.toggle('is-open', !det.hidden);
      }
      return;
    }
    if ((t = e.target.closest('[data-jy-otpa-cancel]'))) return openCancelForm(parseInt(t.getAttribute('data-jy-otpa-cancel'), 10));
    if ((t = e.target.closest('[data-jy-otpa-cxlgo]'))) return cancelOrder(parseInt(t.getAttribute('data-jy-otpa-cxlgo'), 10), t);
    if ((t = e.target.closest('[data-jy-otpa-retopen]'))) return openReturnForm(parseInt(t.getAttribute('data-jy-otpa-retopen'), 10));
    if ((t = e.target.closest('[data-jy-otpa-retsend]'))) return sendReturn(parseInt(t.getAttribute('data-jy-otpa-retsend'), 10), t);
    if ((t = e.target.closest('[data-jy-otpa-retcancel]'))) {
      var b = root.querySelector('[data-jy-otpa-obox="' + t.getAttribute('data-jy-otpa-retcancel') + '"]');
      if (b) b.innerHTML = '';
      return;
    }
    if ((t = e.target.closest('[data-jy-otpa-revopen]'))) return openReviewForm(parseInt(t.getAttribute('data-jy-otpa-revopen'), 10));
    if ((t = e.target.closest('[data-jy-otpa-revsend]'))) return sendReview(parseInt(t.getAttribute('data-jy-otpa-revsend'), 10), t);
    if ((t = e.target.closest('[data-jy-otpa-star]'))) {
      var form = t.closest('[data-jy-otpa-revform]');
      if (!form) return;
      var n = parseInt(t.getAttribute('data-jy-otpa-star'), 10);
      form.setAttribute('data-rating', n);
      form.querySelectorAll('[data-jy-otpa-star]').forEach(function (s, i) {
        s.classList.toggle('is-on', i < n);
      });
    }
  });

  /* ---- reorder: add the order's variants back to the cart ---- */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jy-otpa-reorder]');
    if (!btn) return;
    var o = lastOrders[parseInt(btn.getAttribute('data-jy-otpa-reorder'), 10)];
    if (!o) return;
    var itemsToAdd = o.items
      .filter(function (it) {
        return it.variantId;
      })
      .map(function (it) {
        return { id: it.variantId, quantity: it.qty };
      });
    if (!itemsToAdd.length) return;
    btn.disabled = true;
    btn.textContent = i18n.actions.reordering;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itemsToAdd }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        window.location.href = '/cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = i18n.actions.reorder;
        alert(isAr ? 'بعض المنتجات لم تعد متوفرة.' : 'Certains articles ne sont plus disponibles.');
      });
  });
  function loadOrders(token, phone) {
    currentToken = token;
    listEl.innerHTML = '<div class="jy-codx__loading">…</div>';
    emptyEl.hidden = true;
    show('orders');
    post('/orders', { token: token })
      .then(function (j) {
        renderOrders(j.orders || [], phone, j);
      })
      .catch(function (e2) {
        /* only a rejected session logs out — a flaky mobile connection
           shouldn't kick the customer back to the OTP flow */
        if (String(e2 && e2.message) === 'unauthorized') {
          try {
            localStorage.removeItem(TOKEN_KEY);
          } catch (e) {
            /* noop */
          }
          show('phone');
          return;
        }
        listEl.innerHTML =
          '<div class="jy-otpa__loaderr">' +
          esc(isAr ? 'تعذّر تحميل طلباتك.' : 'Impossible de charger vos commandes.') +
          '<button type="button" class="jy-otpa__obtn" data-jy-otpa-retry>' +
          esc(isAr ? 'إعادة المحاولة' : 'Réessayer') + '</button></div>';
        var rb = listEl.querySelector('[data-jy-otpa-retry]');
        if (rb) {
          rb.addEventListener('click', function () {
            loadOrders(token, phone);
          });
        }
      });
  }

  /* auto-login with a saved session */
  try {
    var t = localStorage.getItem(TOKEN_KEY);
    var p = localStorage.getItem(PHONE_KEY);
    if (t) loadOrders(t, p || '');
  } catch (e) {
    /* noop */
  }
})();
